export default () => process.env.REACT_APP_API_URL;
